export default __webpack_public_path__ + "static/media/Image-Play.2486eba8.png";